<template>
  <!-- FOOTER -->
  <footer>
    <div class="footer-bg">
      <div class="">
        <div class="">
          <section class="container-fluid pb-6">
            <section class="pb-6">
              <div class="row">
                <div class="footer-cta text-center py-5">
                  <h2 class="cta-heading text-white fw-bold mt-1 mb-3">
                    Let's Be Your Tech Partner?
                  </h2>

                  <h4 class="cta-subheading text-secondary fw-normal mb-4">
                    120+ expert engineers & designers in AI, Web, Mobile.
                  </h4>

                  <div class="d-flex justify-content-center mt-4">
                    <a
                      href="https://mediusware.com/contact"
                      class="cta-button position-relative overflow-hidden d-inline-flex align-items-center px-4 py-3 rounded-pill border border-white bg-transparent text-white text-decoration-none"
                    >
                      <span
                        class="z-1 d-flex align-items-center gap-2 text-nowrap fw-medium"
                      >
                        Schedule a Discussion
                        <i class="fas fa-arrow-right icon-transition"></i>
                      </span>

                      <!-- Background Animation -->
                      <div class="cta-bg"></div>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            <div class="row location-section-footer">
              <div class="col-12 col-sm-6 col-lg-3 text-center mb-4">
                <a class="footer-logo" href="#">
                  <img
                    class="img-fluid"
                    src="/assets/logo2.svg"
                    alt="Mediusware Logo"
                  />
                </a>
                <p class="text-white fs-5">
                  Mediusware 2015 - 2025.All Rights Reserved
                </p>
                <div class="d-inline-flex flex-wrap">
                  <a
                    target="_blank"
                    href="https://www.facebook.com/mediusware"
                    class="social-icon-footer"
                  >
                    <img
                      src="/assets/icon/facebook-f-brands.svg"
                      alt="Facebook"
                    />
                  </a>

                  <a
                    target="_blank"
                    href="https://www.instagram.com/mediusware_com/"
                    class="social-icon-footer"
                  >
                    <img
                      src="/assets/icon/instagram-brands-solid-full.svg"
                      class=""
                      alt="Instagram"
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/mediusware-ltd"
                    class="social-icon-footer"
                  >
                    <img
                      src="/assets/icon/linkedin-in-brands.svg"
                      alt="LinkedIn"
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://twitter.com/MediuswareLtd"
                    class="social-icon-footer"
                  >
                    <img src="/assets/icon/twitter-brands.svg" alt="Twitter" />
                  </a>

                  <a
                    target="_blank"
                    href="https://www.youtube.com/watch?v=zrt7SWJXriY&t=5s"
                    class="social-icon-footer"
                  >
                    <img
                      src="/assets/icon/youtube.svg"
                      class=""
                      alt="YouTube"
                    />
                  </a>
                </div>
              </div>
              <div
                v-for="(data, index) in mockData.menu"
                :key="index"
                class="col-lg-5th mb-5"
              >
                <h4 class="text-white font-weight-bold mb-3 footer-link-title">
                  {{ data.title }}
                </h4>
                <div class="d-grid gap-2">
                  <a
                    v-for="(detail, index) in data.items"
                    :key="index"
                    :href="detail.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-white text-sm cursor-pointer hover-effect-footer footer-link-text"
                  >
                    {{ detail.title }}
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
        <!-- <div class="copywriter_mw">
          <p class="text-white">
            © {{ currentYear }} Mediusware || All Rights Reserved
          </p>
        </div> -->
      </div>
    </div>
  </footer>
</template>

<script>
import mockData from "./../pages/footerdata.json";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default {
  data() {
    return {
      mockData,
    };
  },
  computed: {
    awards() {
      return this.$store.state.awards;
    },
    location() {
      return this.$store.state.location;
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
  created() {
    this.$store.dispatch("fetchAwards");
    this.$store.dispatch("fetchOurLocation");
  },
};
</script>

<style scoped lang="scss">
.service-link {
  width: fit-content;
  display: inline;
  position: relative;
  text-decoration: none;
  margin-bottom: 12px !important;
  font-weight: 300;

  &:hover {
    color: #fff !important;
  }

  // after
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    border-radius: 4px;
    background-color: white;
    bottom: 0;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.1s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
}

.col-lg-5th {
  width: 17%; /* 1/5th width for 5 items per row */
  padding-left: 3%;
}

@media screen and (max-width: 990px) {
  .col-lg-5th {
    padding-left: 3%;
    width: 30%; /* 1/5th width for 5 items per row */
  }
}
@media screen and (max-width: 756px) {
  .col-lg-5th {
    padding-left: 5%;
    width: 50%; /* 1/5th width for 5 items per row */
  }
}

.location-img {
  width: 220px;
  height: 130px;
}

.grid-cols-10 {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Default for mobile screens */
  gap: 1rem; /* Adjust spacing */
}

@media (min-width: 768px) {
  /* For tablets and medium screens */
  .grid-cols-10 {
    grid-template-columns: repeat(5, 1fr); /* 5 columns for medium screens */
  }
}
@media (min-width: 1024px) {
  /* For tablets and medium screens */
  .grid-cols-10 {
    grid-template-columns: repeat(7, 1fr); /* 5 columns for medium screens */
  }
}

@media (min-width: 1400px) {
  /* For larger screens (desktop) */
  .grid-cols-10 {
    grid-template-columns: repeat(10, 1fr); /* 10 columns for large screens */
  }
}
.location-section-footer {
  border-top: 1px dashed rgba(164, 170, 173, 0.5);
  padding-top: 50px;
}

.footer-link-title {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.footer-link-text {
  font-size: 0.955rem !important;
  line-height: 1.25rem !important;
}
@media (max-width: 700px) {
  .location-section-footer {
    padding-top: 20px;
  }
  .footer-link-title {
    font-size: 1rem !important;
    line-height: 1rem !important;
  }
}

.hover-effect-footer {
  transition: color 0.3s, text-decoration-color 0.3s;
  text-underline-offset: 5px; /* Creates a 5px gap between text and underline */
}

.hover-effect-footer:hover {
  color: rgb(
    34 211 238
  ) !important; /* Adjust as needed for the hover text color */
  text-decoration: underline !important;
  text-decoration-color: rgb(34 211 238) !important; /* Semi-white underline */
  text-decoration-thickness: 2px; /* Adjust thickness as needed */
}

.footer-cta {
  background: transparent;
}

/* Typography scaling */
.cta-heading {
  font-size: 2.25rem; /* ~36px */
}

@media (min-width: 992px) {
  .cta-heading {
    font-size: 4rem; /* ~64px */
  }
}

.cta-subheading {
  font-size: 0.875rem; /* 14px */
  color: #bfbfbf !important;
}

@media (min-width: 992px) {
  .cta-subheading {
    font-size: 1.5rem; /* 24px */
  }
}

/* Button animation */
.cta-button {
  position: relative;
  transition: color 0.3s ease;
}

.cta-button .cta-bg {
  position: absolute;
  inset: 0;
  background: white;
  border-radius: 50rem;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.5s ease-out;
  z-index: 0;
}

.cta-button:hover .cta-bg {
  transform: scaleX(1);
}

.cta-button:hover span {
  color: var(--primary, #0060af);
}

.icon-transition {
  transition: all 0.5s ease-out;
  transform: rotate(-45deg);
}

.cta-button:hover .icon-transition {
  transform: rotate(0deg);
  color: var(--primary, #0060af);
}
</style>
